import React, { memo, useEffect } from 'react';
import { GridBase } from '../../components';
import strings from '../../globalization';
import {
  trackingSystemList,
  trackingSystemFormReset
} from '../../redux/actions';
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from 'react-redux';

const TrackingSystem = memo(props => {
  const dispatch = useDispatch();
  const { CustomError: customError, err } = useSelector(state => {
    return state.trackingSystemFormData.data;
  });
  useEffect(() => {
    if (customError && err === 'DeleteFailed') {
      Swal.fire({
        title: strings[err],
        text: strings.TrackingSystemLinkedToFacility,
        icon: 'warning'
      });
      dispatch(trackingSystemFormReset());
    }
  }, [customError, err]);

  const columns = [
    {
      key: 'TrackingSystemName',
      name: strings.TrackingSystemName,
      width: 250,
      type: 'text',
      displayValue: 'TrackingSystemName'
    },
    {
      key: 'TrackingSystemContactNames',
      name: strings.TrackingSystemContacts,
      width: 350,
      type: 'text'
    }
  ];

  return (
    <GridBase
      {...props}
      key={Math.random()}
      columns={columns}
      title={strings.TrackingSystem}
      comboType={['CountryCode', 'TrackingSystemContact']}
      loadPref={true}
      listId="TrackingSystem"
      dataProperty="trackingSystemListData"
      parentRoute="trackingSystem"
      action={trackingSystemList}
      sortColumn={'TrackingSystemName'}
      gridSortDirection={'ASC'}
    />
  );
});

export default TrackingSystem;
